"use client";

import React, { useEffect, useRef } from 'react';

interface NoiseBgProps {
  className?: string;
}

const NoiseBg: React.FC<NoiseBgProps> = ({ className = '' }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const resizeThrottleRef = useRef<NodeJS.Timeout | null>(null);

  const createNoise = (
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number
  ): void => {
    const idata = ctx.createImageData(width, height);
    const buffer32 = new Uint32Array(idata.data.buffer);
    const len = buffer32.length;

    for (let i = 0; i < len; i++) {
      if (Math.random() < 0.5) {
        buffer32[i] = 0xff777777;
      }
    }

    ctx.putImageData(idata, 0, 0);
  };

  const setup = (): void => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    if (!ctx) return;

    // Set canvas size
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Generate noise
    createNoise(ctx, canvas.width, canvas.height);
  };

  useEffect(() => {
    setup();

    const handleResize = (): void => {
      if (resizeThrottleRef.current) {
        clearTimeout(resizeThrottleRef.current);
      }

      resizeThrottleRef.current = setTimeout(() => {
        setup();
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeThrottleRef.current) {
        clearTimeout(resizeThrottleRef.current);
      }
    };
  }, []);

  return (
    <div className={`fixed top-0 left-0 w-full h-full pointer-events-none ${className}`}>
      <canvas
        ref={canvasRef}
        className="w-full h-full"
        style={{ opacity: 0.05 }}
      />
    </div>
  );
};

export default NoiseBg;